<template>
  <img style="position: absolute;width: 30px;" src="/img/discount.png"/>
</template>
<script>
export default {
  name: "NewYearIcon",
}
</script>
